import { Post } from '@/scripts/types'

export const postsManifest: Post[] = [
  {
    "slug": "aws-dea-c01-02",
    "data": {
      "title": "AWS Glue DataBrew using AWS CDK",
      "created": "2025-03-30",
      "excerpt": "This is the second post in a series on Data Engineering with AWS. In this post, I’d like to share my thoughts and key takeaways from experiments I’ve conducted with the AWS Glue DataBrew service - particularly from an Infrastructure as Code (IaC) perspective, as well as building a data pipeline to transform and merge files stored in S3 to make them ready for further analytical processing.",
      "tags": [
        "Data Engineering",
        "Glue DataBrew",
        "DEA-C01",
        "AWS CDK"
      ]
    }
  },
  {
    "slug": "aws-dea-c01-01",
    "data": {
      "title": "Data Engineering Fundamentals",
      "created": "2025-01-09",
      "excerpt": "This is the first post in a series on Data Engineering with AWS. In this post, we will cover some basic terminology related to data engineering that can be useful as a foundation before diving into AWS services.",
      "tags": [
        "AWS",
        "Data Engineering",
        "DEA-C01"
      ]
    }
  },
  {
    "slug": "understanding-nodejs-memory-part1",
    "data": {
      "title": "Understanding Node.js - Memory management",
      "created": "2024-12-08",
      "excerpt": "This is the fourth article in our series on understanding the architecture of Node.js. In this post, we explore how Node.js manages memory, discuss methods to detect memory leaks, and review some of the most common issues that can cause them.",
      "tags": [
        "Node.js",
        "Memory leak",
        "Memory management",
        "Profiling"
      ]
    }
  },
  {
    "slug": "understanding-nodejs-cpu-part3",
    "data": {
      "title": "Understanding Node.js - Profiling",
      "created": "2024-11-11",
      "excerpt": "This is the third post related to understanding architecture of Node.js. In this article we will explore built in Node.js mechanism we can use to profile application to detect bottlenecks and fix them.",
      "tags": [
        "Node.js",
        "Event Loop",
        "CPU",
        "Profiling"
      ]
    }
  },
  {
    "slug": "understanding-nodejs-cpu-part2",
    "data": {
      "title": "Understanding Node.js - Performance optimization",
      "created": "2024-11-10",
      "excerpt": "This is the second post related to understanding architecture of Node.js. In this article we will focus on understanding how we can optimize and manage heavy CPU tasks to make our app responsive.",
      "tags": [
        "Node.js",
        "EventLoop",
        "CPU",
        "Performance optimization"
      ]
    }
  },
  {
    "slug": "understanding-nodejs-cpu-part1",
    "data": {
      "title": "Understanding Node.js - Event loop",
      "created": "2024-11-04",
      "excerpt": "This is the first part of a series of posts related to understanding architecture of Node.js. In this article we will focus on understanding an Event Loop concept.",
      "tags": [
        "Node.js",
        "Event Loop",
        "CPU",
        "JS"
      ]
    }
  },
  {
    "slug": "aws-athena-01",
    "data": {
      "title": "Partition projection with Amazon Athena",
      "created": "2024-10-08",
      "excerpt": "This guide provides instructions for querying data in Amazon Athena, both with and without the integration of AWS Glue Data Catalog.",
      "tags": [
        "AWS",
        "S3",
        "Athena"
      ]
    }
  },
  {
    "slug": "aws-kinesis-01",
    "data": {
      "title": "Fraud detection with Kinesis Data Analytics",
      "created": "2023-05-31",
      "excerpt": "Step by step guide how to process real time data with Kinesis Data Analytics",
      "tags": [
        "AWS",
        "Kinesis Data Stream",
        "Kinesis Data Analytics",
        "Apache Flink",
        "Java"
      ]
    }
  },
  {
    "slug": "aws-iot-athena-03",
    "data": {
      "title": "Athena to read IoT data (part 3)",
      "created": "2023-04-02",
      "excerpt": "Step by step guide how to process raw data to make it available for analytical systems",
      "tags": [
        "AWS",
        "Glue",
        "Crawler",
        "ETL",
        "PySpark",
        "Athena"
      ]
    }
  },
  {
    "slug": "aws-iot-athena-02",
    "data": {
      "title": "Athena to read IoT data (part 2)",
      "created": "2023-02-25",
      "excerpt": "Step by step guide how to create an IoT device simulator with Typescript and NodeJS",
      "tags": [
        "AWS",
        "IoT Core",
        "NodeJS",
        "Typescript"
      ]
    }
  },
  {
    "slug": "aws-iot-athena-01",
    "data": {
      "title": "Athena to read IoT data (part 1)",
      "created": "2023-02-18",
      "excerpt": "Step by step guide how to store IoT data in S3 and leverage AWS services to process and make the data available for Athena",
      "tags": [
        "AWS",
        "S3",
        "IoT Core",
        "Terraform"
      ]
    }
  }
]
